import ProfileMenuContainer from './ProfileMenuContainer';

export default ProfileMenuContainer;
